/** Ce are nevoie interfața de tuning din fișa motorului (aceleași date ca în data/bodies/*.json). */
export interface PowertrainInfo {
  fuel: 'petrol' | 'diesel';
  carburetor: boolean;
  ecu: boolean;
  turbo: boolean;
  spoolRpm: [number, number];
  idleRpm: number;
  redlineRpm: number;
  limiterRpm: number;
  cylinders: number;
  gears: number;
  transmission: string;
  efficiency: number;
}

export function powertrainInfo(body: { powertrain?: { fuel: 'petrol' | 'diesel'; carburetor: boolean; ecu: boolean; turbo: { spoolRpm: [number, number] } | null; idleRpm: number; redlineRpm: number; limiterRpm: number; cylinders: number; gears: number[]; transmission: string; efficiency: number } }): PowertrainInfo | null {
  const p = body.powertrain;
  if (!p) return null;
  return { fuel: p.fuel, carburetor: p.carburetor, ecu: p.ecu, turbo: !!p.turbo, spoolRpm: p.turbo?.spoolRpm ?? [0, 1], idleRpm: p.idleRpm, redlineRpm: p.redlineRpm, limiterRpm: p.limiterRpm, cylinders: p.cylinders, gears: p.gears.length, transmission: p.transmission, efficiency: p.efficiency };
}
